
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "b561b2d79c44c3ac49cb.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					w.ready = new Promise(function(r) { w.addEventListener("ready", function(){ r(w) }) })
					return w
				}
			